import { participantCopyText } from '../catalogue/lookupParticipantCopyText.js';
import { FILLED_VALUE, RUNTIME_VALUE } from '../internal/placeholderPatterns.js';
/**
 * What is wrong with one language's stored texts, in the order of its keys;
 * none when they can be saved. A text may only hold the values its own text
 * gets: the app's (`{{time}}`) and Clair's (`{company}`).
 */
export function participantCopyProblems(copy) {
    const problems = [];
    for (const [key, text] of Object.entries(copy)) {
        const entry = participantCopyText(key);
        if (!entry || typeof text !== 'string') {
            problems.push({ key, problem: 'unknown_text' });
            continue;
        }
        if (text.length > entry.maxLength) {
            problems.push({ key, problem: 'too_long', maxLength: entry.maxLength });
        }
        if (entry.locked && text.trim() === '') {
            problems.push({ key, problem: 'required' });
        }
        for (const [, value] of text.matchAll(RUNTIME_VALUE)) {
            if (value && !entry.vars.includes(value)) {
                problems.push({ key, problem: 'unknown_value', value: `{{${value}}}` });
            }
        }
        for (const [, value] of text.matchAll(FILLED_VALUE)) {
            if (value && !entry.fills.includes(value)) {
                problems.push({ key, problem: 'unknown_value', value: `{${value}}` });
            }
        }
    }
    return problems;
}
//# sourceMappingURL=participantCopyProblems.js.map